module.exports = __webpack_public_path__ + "img/hah-logo.bb94516e.png";